import React, { useState, useEffect } from 'react';
import { default as getLabelFromStorage } from "@pb/utils/labels/getLabelFromStorage";
import { trackOptimizelyVanillaEvent } from "@pb/utils/optimizely";
import { default as isTouchDevice } from "@pb/utils/isTouchDevice";
import IntersectionVisible from "../../../../helpers/IntersectionVisible";
import constants from '../../constants';
import { AbEvents } from '../../helpers/optimizely/optimizelyConstants';
import { handleClick, triggerCarouselImpression } from '../../helpers/tracking';
import ProductCarouselNS from './ProductCarouselNS';
const uiLabels = {
    next: getLabelFromStorage('general.next'),
    prev: getLabelFromStorage('general.previous'),
};
const CarouselNS = ({ className, praConfiguration, carouselTitle, modelInfo = '', finalProducts, articleId, imageType, origin = '', textNext, textPrev, setTrackedArticles, trackedArticles, isLoading, breakpoint, }) => {
    const [trackedProductsOnImpression, setTrackedProductsOnImpression] = useState([]);
    const [carouselIsShown, setCarouselIsShown] = useState(false);
    const initialImpressionParams = {
        praConfiguration,
        carouselTitle,
        origin,
        modelInfo,
    };
    const { RESOLVER: resolverSettings, ID, NUM_OF_ITEMS_PER_SLIDE, THRESHOLD, DESCRIPTION_SIZE, HEADING_SIZE, PRODUCT_TITLE_TRUNCATE, LAZYLOAD_IMAGES, } = praConfiguration;
    const [visibleItemsInCarousel, setVisibleItemsInCarousel] = useState(NUM_OF_ITEMS_PER_SLIDE[breakpoint]);
    const [lastIndex, setLastIndex] = useState(null);
    // TODO: remove when API sourced labels available for brands
    if (textNext && textPrev) {
        uiLabels.next = textNext;
        uiLabels.prev = textPrev;
    }
    const productClick = (params) => {
        handleClick(params);
    };
    const impression = (event, onShow) => {
        if (!isLoading) {
            const params = Object.assign(Object.assign(Object.assign(Object.assign({}, initialImpressionParams), { productSet: finalProducts, visibleItemsInCarousel,
                trackedProductsOnImpression, articleId: articleId || ID }), (onShow && { onShow })), (event && { event }));
            const latestTrackedArticles = triggerCarouselImpression(params);
            setTrackedProductsOnImpression(latestTrackedArticles);
            if (setTrackedArticles) {
                setTrackedArticles(latestTrackedArticles);
            }
        }
    };
    const handleFavouritesClick = (isFav) => {
        let eventName;
        if (ID === 'PRA1') {
            eventName = AbEvents.ON_ATF_OTHERS_ALSO_BOUGHT_CLICK;
        }
        else if (ID === 'SWG') {
            eventName = AbEvents.ON_ATF_STYLE_WITH_CLICK;
        }
        else if (ID === 'PRA2') {
            eventName = AbEvents.ON_ATF_RELATED_ARTICLES_CLICK;
        }
        if (isFav && eventName) {
            trackOptimizelyVanillaEvent(eventName);
        }
    };
    useEffect(() => {
        const amountOfVisualSlidesForBreakpoint = NUM_OF_ITEMS_PER_SLIDE[breakpoint];
        if (amountOfVisualSlidesForBreakpoint !== visibleItemsInCarousel) {
            setVisibleItemsInCarousel(amountOfVisualSlidesForBreakpoint);
        }
    }, [breakpoint]);
    useEffect(() => {
        if (lastIndex !== null) {
            impression(lastIndex, false);
        }
    }, [visibleItemsInCarousel]);
    useEffect(() => {
        if (carouselIsShown && (finalProducts === null || finalProducts === void 0 ? void 0 : finalProducts.length)) {
            impression(false, true);
            setLastIndex(0);
        }
    }, [carouselIsShown, finalProducts]);
    useEffect(() => {
        if (trackedArticles) {
            setTrackedProductsOnImpression(trackedArticles);
        }
    }, []);
    if (!finalProducts || finalProducts.length === 0) {
        return null;
    }
    return (React.createElement(IntersectionVisible, { className: className, onShow: () => {
            setCarouselIsShown(true);
        }, onHide: () => {
            setCarouselIsShown(false);
        }, active: true, options: {
            threshold: THRESHOLD || 0.1,
        } },
        React.createElement(ProductCarouselNS, { key: `product-reco-${ID}-${articleId || 'default'}`, onAfterChange: (e) => {
                if (carouselIsShown) {
                    impression(e, false);
                }
            }, linkClickCallback: (e) => {
                const params = {
                    event: e,
                    productSet: finalProducts,
                    modelInfo,
                    praConfiguration,
                    origin,
                    carouselTitle,
                };
                if (isTouchDevice()) {
                    productClick(params);
                }
            }, title: carouselTitle || '', products: finalProducts, labels: uiLabels, useModelAsDefault: (imageType && imageType.toLowerCase() !== constants.IMAGE_TYPES.PRODUCT) || false, className: ID.toLowerCase(), onlyArrows: false, titleSize: HEADING_SIZE, shouldProtectSliderClick: !(LAZYLOAD_IMAGES || process.env.IS_PRA_LP_RESOLVER_ENABLED === 'enabled'), lazyLoad: process.env.IS_PRA_LP_RESOLVER_ENABLED === 'enabled' ? 'progressive' : undefined, descriptionFontSize: DESCRIPTION_SIZE || undefined, reserveHeightAspectRatio: resolverSettings && `${resolverSettings.WIDTH}/${resolverSettings.HEIGHT}`, shouldTruncateProductTitle: PRODUCT_TITLE_TRUNCATE && false, onFavouritesClick: handleFavouritesClick })));
};
export default CarouselNS;
//# sourceMappingURL=CarouselNS.js.map